var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetric = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 14.5a1.5 1.5 0 0 0 1.302-2.244l-6-10.5a1.5 1.5 0 0 0-2.604 0l-6 10.5A1.5 1.5 0 0 0 2 14.5h12zM12.111 13 8 10.362 3.888 13h8.223zm1.374-.9L8.75 3.812v5.249l4.735 3.039zM7.25 3.813l-4.735 8.286L7.25 9.061V3.813z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetric);
export default ForwardRef;